export default [
  {
    name: 'bedexitenvironment',
    path: '/deviceEnv',
    component: () => import('@/views/bedExitMonitor/deviceEnv/Index')
  },
  {
    name: 'bedexitenvironment_add',
    path: '/deviceEnv/add',
    component: () => import('@/views/bedExitMonitor/deviceEnv/Add')
  },
  {
    name: 'bedexitenvironment_edit',
    path: '/deviceEnv/edit/:mac/:env',
    component: () => import('@/views/bedExitMonitor/deviceEnv/Edit')
  },
  {
    name: 'bedexitfacility',
    path: '/deviceManage',
    component: () => import('@/views/bedExitMonitor/deviceManage/Index')
  },
  {
    name: 'bedexitfacility_edit',
    path: '/deviceManage/edit/:id',
    component: () => import('@/views/bedExitMonitor/deviceManage/Edit')
  },
  {
    name: 'bedexitview',
    path: '/bedexitview',
    component: () => import('@/views/bedExitMonitor/deviceView/Index.vue')
  },
  {
    name: 'bedexitview_person',
    path: '/bedexitview/person/:id',
    component: () => import('@/views/bedExitMonitor/deviceView/PersonRecord.vue')
  },
  {
    name: 'bedexitreset',
    path: '/deviceReset',
    component: () => import('@/views/bedExitMonitor/deviceReset/Index')
  },
  {
    name: 'bedexitreport',
    path: '/deviceReport',
    component: () => import('@/views/bedExitMonitor/deviceReport/Index')
  },
  {
    name: 'bedexitbatchupload',
    path: '/deviceBatchUpload',
    component: () => import('@/views/bedExitMonitor/deviceBatchUpload/Index')
  },
  {
    name: 'bedexitrawdata',
    path: '/deviceRawData',
    component: () => import('@/views/bedExitMonitor/deviceRawData/Index')
  }
]
